import React from "react";
import {Field as AntField} from "formik-antd";
import {useTranslation} from "react-i18next";
import {ErrorMessage, Field as FormikField} from "formik";
import {checkField} from "helpers/helper";

const SectionFormField = ({label, errorName, ...props}) => {
  const {t} = useTranslation();

  const readOnlyValue =
    typeof props?.name === "string" ? (
      <FormikField name={props.name}>
        {({field}) => <p className="custom-text mt-4 ml-2 mb-2">{field?.value ?? ""}</p>}
      </FormikField>
    ) : (
      <p className="custom-text mt-4 ml-2 mb-2">
        {props?.value ?? props?.defaultValue ?? ""}
      </p>
    );

  return (
    <div className="field">
      {!!props?.disabled ? (
        label ? (
          <div className="df-row-baseline">
            <span className="label mr-0">{t(label)}</span>
            {readOnlyValue}
          </div>
        ) : (
          readOnlyValue
        )
      ) : (
        <React.Fragment>
          {label && <label className="label">{t(label)}</label>}
          <AntField {...props} />
        </React.Fragment>
      )}
      {errorName && (
        <ErrorMessage name={errorName}>
          {(msg) => <p className="form-error">{checkField(msg)}</p>}
        </ErrorMessage>
      )}
    </div>
  );
};

export default SectionFormField;
